import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PageHero, PrimaryLink, Overline } from "@/components/site";
import { WHY_TWORAY, COMPANY } from "@/data/content";

const ABOUT_IMG = "https://images.unsplash.com/photo-1758518731706-be5d5230e5a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  return (
    <div data-testid="page-about">
      <SEO title="Why TWORAY" description="Why TWORAY — independent, business-first technology and cyber security advisory. Direct expert involvement, practical security and clear roadmaps." />
      <PageHero overline="Why TWORAY" title="Boutique by design. Direct by default."
        subtitle="A boutique advisory business built on direct expert involvement, independence and pragmatic, commercially-aware recommendations." />

      <section className="py-20 sm:py-24">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="relative overflow-hidden rounded-md border border-brandborder aspect-[4/3]">
              <img src={ABOUT_IMG} alt="TWORAY advisory" className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <Overline>Our positioning</Overline>
            <h2 className="mt-4 font-heading font-bold tracking-tight text-3xl sm:text-4xl text-navy">{COMPANY.positioning}</h2>
            <p className="mt-5 text-slate text-lg leading-relaxed">{COMPANY.principle}</p>
            <p className="mt-4 text-slate leading-relaxed">
              TWORAY helps startups, scale-ups and growing organisations understand technology risk, make better decisions,
              and build practical roadmaps for secure, sustainable growth. You work directly with the advisor responsible
              for understanding your organisation and developing your recommendations — fewer hand-offs, senior attention.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-16 sm:py-24 bg-navy text-white grain-overlay relative">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 relative z-10">
          <Reveal><Overline dark>Why work with us</Overline>
            <h2 className="mt-4 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-2xl">What makes working with TWORAY different.</h2>
          </Reveal>
          <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3 border border-white/10">
            {WHY_TWORAY.map((w, i) => (
              <Reveal key={w.num} delay={(i % 3) * 0.06}>
                <div className="bg-navy p-8 sm:p-10 h-full" data-testid={`about-why-${w.num}`}>
                  <span className="font-heading font-extrabold text-4xl text-transparent [-webkit-text-stroke:1px_#19AFFF]">{w.num}</span>
                  <h3 className="mt-3 font-heading font-bold text-xl">{w.title}</h3>
                  <p className="mt-3 text-white/65 leading-relaxed">{w.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal><div className="mt-14 text-center"><PrimaryLink to="/book" dark data-testid="about-book-cta">Book a Discovery Call</PrimaryLink></div></Reveal>
        </div>
      </section>
    </div>
  );
}
